import cn from 'clsx';
import MaskedInput from 'react-text-mask';

import ResetIcon from '@/public/images/resetInput.svg';

import css from '../styles/Input.module.css';
import {MASKS, TYPES, WIDTH} from './Input';

interface SimpleInputProps {
  placeholder?: string;
  width?: string;
  mask?: string;
  handleResetClick?: (...args: any) => any;
  onChange: (...args: any) => any;
  disabled?: boolean;
  isRequired?: boolean;
  isRedBorder?: boolean;
  value?: string | number;
  error?: string;
  inputRef?: any;
  type?: string;
  defaultValue?: string | number;
  min: any;
}
const SimpleInput = ({
  placeholder,
  width,
  mask,
  handleResetClick,
  disabled,
  isRequired,
  value,
  onChange,
  error,
  isRedBorder,
  inputRef,
  ...props
}: SimpleInputProps) => {
  const inputProps = {
    className: css.inputField,
    placeholder: placeholder,
    disabled,
  };

  const InputComponent = mask ? (
    <MaskedInput
      {...inputProps}
      mask={mask}
      guide={false}
      value={value}
      onChange={onChange}
      ref={inputRef}
      {...props}
    />
  ) : (
    <input
      {...inputProps}
      value={value}
      onChange={onChange}
      {...props}
      ref={inputRef}
    />
  );

  return (
    <div className={cn(css.inputBlock, css[width])}>
      <div
        className={cn(
          error || isRedBorder ? css.inputAreaError : css.inputAreaCommon,
          css.inputArea,
          disabled && css.inputAreaDisabled
        )}
      >
        {isRequired && <div className={css.requiredIcon}>*</div>}
        {InputComponent}
        {Boolean(handleResetClick) && (
          <div className={css.resetIcon} onClick={handleResetClick}>
            <ResetIcon />
          </div>
        )}
      </div>
      {Boolean(error) && <div className={css.errorField}>{error}</div>}
    </div>
  );
};

SimpleInput.WIDTH = WIDTH;
SimpleInput.TYPES = TYPES;
SimpleInput.MASKS = MASKS;

export default SimpleInput;
